import * as React from 'react';
import { Box, Typography, Container, IconButton } from '@mui/material';
import { ThemeClient } from '../contexts/Theme';

import Logo from '../components/Logo';
import RewardsList from '../components/rewards/RewardsList';
import Navbar from '../Navbar';

import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/auth';

import { ConfirmationNumber } from '@mui/icons-material';
import { useState } from 'react';

export default function Ranking() {
    const [rewards, setRewards] = React.useState([]);
    const { user } = useAuth();

    const [score, setScore] = React.useState(null)

    async function getUser() {
        var { data, error } = await supabase
            .from('users')
            .select('score')
            .eq('id', user.id)
            .limit(1)
            .single()

        setScore(data.score)
    }

    async function fetchRewards() {
        try {
            const { data, error } = await supabase.from('rewards')
            .select('*')
            .order('score');
            if (error) {
                throw error;
            }
            setRewards(data);
        } catch (error) {
            console.error('Error fetching rewards:', error.message);
        }
    }

    React.useEffect(() => {
        fetchRewards();
        getUser()
    }, []);

    if (!score) return <></>

    return (
        <ThemeClient>
            <Navbar title={'Recompensas'} />
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem',
                }}
            >
                <Logo
                    style={{
                        height: 'auto',
                        maxWidth: '100%',
                        marginBottom: '2rem',
                    }}
                />
            </Box>

            <Container>
                <Box display="flex" alignItems="center">
                    <IconButton color="primary">
                        <ConfirmationNumber />
                    </IconButton>

                    <Typography variant="h6">Tus Puntos: {score}</Typography>
                </Box>
            </Container>

            <RewardsList rewards={rewards} userScore={score} setScore={setScore} />
        </ThemeClient>
    );
}
